import React, { useEffect, useState, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { displayNotification, generateOptionsFromData, getBaseURL, sendAPIRequest } from "../../../helpers";
import { IoIosArrowForward, IoMdAdd, IoMdRemoveCircleOutline } from "react-icons/io";
import TextFieldCustom from "components/TextFieldCustom";
import DataTable from "pages/components/DataTable";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { Card, CardContent, IconButton, Tooltip, Typography, styled, tooltipClasses } from "@mui/material";
import { Add } from "@material-ui/icons";
import Spinner from "components/spinner/Spinner";
import PrintIcon from '@mui/icons-material/Print';
import { useReactToPrint } from 'react-to-print';
import { changeSiteLanguage } from "index";
import { useDispatch, useSelector } from "react-redux";
import logo from "images/WOAH_ANNIVERSARY_PRIMARY LOGO_ORANGE + GOLD_ENG.png";
import logoF from "images/WOAH_ANNIVERSARY_PRIMARY LOGO_ORANGE + GOLD_FRA.png";
import logoS from "images/WOAH_ANNIVERSARY_PRIMARY LOGO_ORANGE + GOLD_ESP.png";
import { FaArrowRight } from "react-icons/fa";
import { MdArrowForwardIos } from "react-icons/md";

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#ffece8',
        color: '#ff4815',
        boxShadow: theme.shadows[1],
        fontSize: 12,
        padding: '13px'
    },
}));


const CompareData = ({ isProfile, expertId, onNext, onPrev }) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const componentRef = useRef(null);
    const [personData, setPersonData] = useState({});
    const [languageData, setLanguageData] = useState({});
    const [expertAreaData, setExpertAreaData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const siteLanguage = useSelector((s) => s.general.siteLanguage);

    useEffect(() => {
        if (id) {
            getPersonData(id);
            getLanguageData(id);
            getExpertAreaData(id);
        }
    }, []);


    const getPersonData = async (id) => {
        try {
            setIsLoading(true);
            const req = await sendAPIRequest(`/api/expert-comparison/person/${id}`);
            const res = await req.json();
            if (res.success) {
                setPersonData(res.data)
            } else {
                displayNotification("error", `${t("222", "Error loading data")} [B]`);
            }
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            console.log(e);
            displayNotification("error", `${t("222", "Error loading data")} [F]`);
        }
    };
    const getLanguageData = async (id) => {
        try {
            setIsLoading(true);
            const req = await sendAPIRequest(`/api/expert-comparison/languages/${id}`);
            const res = await req.json();
            if (res.success) {
                setLanguageData(res.data)
            } else {
                displayNotification("error", `${t("222", "Error loading data")} [B]`);
            }
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            console.log(e);
            displayNotification("error", `${t("222", "Error loading data")} [F]`);
        }
    };

    const getExpertAreaData = async (id) => {
        try {
            setIsLoading(true);
            const req = await sendAPIRequest(`/api/expert-comparison/area/${id}`);
            const res = await req.json();
            if (res.success) {
                setExpertAreaData(res.data)
            } else {
                displayNotification("error", `${t("222", "Error loading data")} [B]`);
            }
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            console.log(e);
            displayNotification("error", `${t("222", "Error loading data")} [F]`);
        }
    };
    const hasNewData = () => {
        return personData.newData?.salutation ||
            personData.newData?.first_name ||
            personData.newData?.last_name ||
            personData.newData?.gender_ref?.list_element_name ||
            personData.newData?.contact ||
            personData.newData?.professional_contact ||
            personData.newData?.email ||
            personData.newData?.professional_email ||
            personData.newData?.address ||
            personData.newData?.country?.country_name;
    };
    const handlePrint = useReactToPrint({
        contentRef: componentRef,
        // onAfterPrint: () => {
        //     window.close();
        // },
    });
    return (
        <>
            <div className="container my-2 ">
                <div className="header card-woah border border-secondary d-flex px-4 py-2 shadow-sm w-100 my-2">
                    {/* <div className="d-flex"> */}
                    <div className="card-title1 lh-1">
                        {t("-1", "CRM Expert Profile Changes")}
                    </div>
                    <LightTooltip title="Print report" placement="top"
                    >
                        <IconButton
                            // onClick={() => handlePrint()}
                            onClick={handlePrint}

                        >
                            <PrintIcon
                                color='primary'
                            // onClick={handlePrint}
                            />
                        </IconButton>
                    </LightTooltip>
                    {/* </div> */}


                    <div className="header-right-items ms-auto d-flex align-items-center">
                        <Link to={"/portal/experts-management/"} className="ms-auto">
                            <button className="btn btn--primary fs-7 lh-1">
                                {" "}
                                <i className="fas fa-angle-left text-white" />
                                {t("32", "Back")}
                            </button>
                        </Link>
                    </div>
                </div>


                <div ref={componentRef} className="header card-woah border border-secondary pb-2 shadow-sm w-100 my-2 custom_header">
                    <div className="custom_print_header ">
                        {siteLanguage === "3" && (
                            <div
                                className=""
                                id="logo-brand"
                                to="/"
                            >
                                <img src={logo} height="50px" />
                            </div>
                        )}
                        {siteLanguage === "5" && (
                            <div
                                className=""
                            >
                                <img src={logoF} height="50px" />
                            </div>
                        )}

                        {siteLanguage === "4" && (
                            <div
                                className=""
                            >
                                <img src={logoS} height="50px" />
                            </div>
                        )}
                        <h2 className="my-0 border border-2 custom_title border border-right-0 border-top-0 border-bottom-0 border-dark ps-3">
                            {t("-1", "PVSIS")}
                        </h2>

                    </div>
                    <div>
                        {
                            isLoading ? (
                                <Spinner message={`${t("347", "Extracting")}`} />
                            ) : (
                                <div className="row g-0 mb-5 " >
                                    <div className="col-6 ">
                                        <img src={getBaseURL("/assets/icons/animal-disease-3.webp")} alt="" className=' w-100 object-fit-cover h-100' />
                                    </div>
                                    <div className="col-6 card_custom_parent position-relative">
                                        <div className=" d-flex justify-content-between flex-column gap-5 p-10 card_custom" >
                                            <div className=" d-flex gap-5 card_child_bgc justify-content-between align-items-center p-5 ">
                                                <h6 className="text-black m-0">CRM ID :</h6>
                                                <p className="m-0 text-black">{personData.oldData?.crm_id || 'N/A'}</p>
                                            </div>
                                            <div className=" d-flex gap-5 card_child_bgc justify-content-between align-items-center p-5  ">
                                                <h6 className="text-black m-0">Name :</h6>
                                                <p className="m-0 text-black">{personData.oldData?.person?.full_name || 'N/A'}</p>
                                            </div>
                                            <div className=" d-flex gap-5 card_child_bgc justify-content-between align-items-center p-5  ">
                                                <h6 className="text-black m-0">Email :</h6>
                                                <p className="m-0 text-black">{personData.oldData?.person?.professional_email || 'N/A'}</p>
                                            </div>
                                            <div className=" d-flex gap-5 card_child_bgc justify-content-between align-items-center p-5  ">
                                                <h6 className="text-black m-0">Salutation :</h6>
                                                <p className="m-0 text-black">{personData.oldData?.person?.salutation || 'N/A'}</p>
                                            </div>
                                        </div>
                                        <Link to={`/portal/experts-management/${id}/view`} className="position-absolute view_more_link d-flex align-items-center gap-1">
                                            <h6 className="text-primary m-0">View More</h6>
                                            <MdArrowForwardIos />

                                        </Link>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    {hasNewData() &&
                        <div>
                            <div className="header card-woah border border-secondary d-flex px-4 py-2 shadow-sm w-100 my-2">
                                <div className="card-title1 lh-1">
                                    {t("-1", "Person Information")}
                                </div>
                            </div>
                            {
                                isLoading ? (
                                    <Spinner message={`${t("347", "Extracting")}`} />
                                ) : (
                                    <div className="m-5">
                                        <table className="table table-bordered mt-3">
                                            <thead className="bg-primary">
                                                <tr className="text-white">
                                                    <th >Field</th>
                                                    <th>Old Value</th>
                                                    <th>New Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {personData.newData?.salutation && (
                                                    <tr>
                                                        <td className="fw-bold">Title</td>
                                                        <td>{personData.oldData?.person?.salutation}</td>
                                                        <td>{personData.newData?.salutation}</td>
                                                    </tr>
                                                )}
                                                {personData.newData?.first_name && (
                                                    <tr>
                                                        <td className="fw-bold">First Name</td>
                                                        <td>{personData.oldData?.person?.first_name}</td>
                                                        <td>{personData.newData?.first_name}</td>
                                                    </tr>
                                                )}
                                                {personData.newData?.last_name && (
                                                    <tr>
                                                        <td className="fw-bold">Last Name</td>
                                                        <td>{personData.oldData?.person?.last_name}</td>
                                                        <td>{personData.newData?.last_name}</td>
                                                    </tr>
                                                )}
                                                {personData.newData?.gender_ref?.list_element_name && (
                                                    <tr>
                                                        <td className="fw-bold">Gender</td>
                                                        <td>{personData.oldData?.person?.gender_ref?.list_element_name}</td>
                                                        <td>{personData.newData?.gender_ref?.list_element_name}</td>
                                                    </tr>
                                                )}
                                                {personData.newData?.contact && (
                                                    <tr>
                                                        <td className="fw-bold">Personal Contact</td>
                                                        <td>{personData.oldData?.person?.contact}</td>
                                                        <td>{personData.newData?.contact}</td>
                                                    </tr>
                                                )}
                                                {personData.newData?.professional_contact && (
                                                    <tr>
                                                        <td className="fw-bold">Professional Contact</td>
                                                        <td>{personData.oldData?.person?.professional_contact}</td>
                                                        <td>{personData.newData?.professional_contact}</td>
                                                    </tr>
                                                )}
                                                {personData.newData?.email && (
                                                    <tr>
                                                        <td className="fw-bold">Personal Email</td>
                                                        <td>{personData.oldData?.person?.email}</td>
                                                        <td>{personData.newData?.email}</td>
                                                    </tr>
                                                )}
                                                {personData.newData?.professional_email && (
                                                    <tr>
                                                        <td className="fw-bold">Professional Email</td>
                                                        <td>{personData.oldData?.person?.professional_email}</td>
                                                        <td>{personData.newData?.professional_email}</td>
                                                    </tr>
                                                )}
                                                {personData.newData?.address && (
                                                    <tr>
                                                        <td className="fw-bold">Address</td>
                                                        <td>{personData.oldData?.person?.address}</td>
                                                        <td>{personData.newData?.address}</td>
                                                    </tr>
                                                )}
                                                {personData.newData?.country?.country_name && (
                                                    <tr>
                                                        <td className="fw-bold">Country Of Residence</td>
                                                        <td>{personData.oldData?.person?.residence_ref?.country_name}</td>
                                                        <td>{personData.newData?.country?.country_name}</td>
                                                    </tr>
                                                )}
                                            </tbody>

                                        </table>
                                    </div>

                                )
                            }
                        </div>
                    }

                    {
                        Array.isArray(languageData) && languageData.some(lang => lang.temp_expert_language?.language?.language) && (
                            <div className="mt-4">
                                <div className="header card-woah border border-secondary d-flex px-4 py-2 shadow-sm w-100 my-2">
                                    <div className="card-title1 lh-1">
                                        {t("-1", "Language Information")}
                                    </div>
                                </div>

                                {
                                    isLoading ? (
                                        <Spinner message={`${t("347", "Extracting")}`} />
                                    ) : (
                                        <div className="m-5">
                                            <table className="table table-bordered mt-3">
                                                <thead className="bg-primary">
                                                    <tr className="text-white">
                                                        <th>Field</th>
                                                        <th>Old Value</th>
                                                        <th>New Value</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        languageData.map((lang, index) =>
                                                            lang.temp_expert_language?.language?.language ? (
                                                                <tr key={index}>
                                                                    <td className="fw-bold">Language</td>
                                                                    <td>{lang.language?.language}</td>
                                                                    <td>{lang.temp_expert_language.language.language}</td>
                                                                </tr>
                                                            ) : null
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }
                    {
                        Array.isArray(expertAreaData) && expertAreaData.some(area => area?.temp) && (
                            <div className="mt-4">
                                <div className="pvs-title fw-bold fs-2 text-center lh-1 py-5 bg-light-orange">
                                    {t("-1", "Area of Expertise Information")}
                                </div>
                                {
                                    isLoading ? (
                                        <Spinner message={`${t("347", "Extracting")}`} />
                                    ) : (
                                        <div className="m-5">
                                            <table className="table table-bordered mt-3">
                                                <thead className="bg-primary">
                                                    <tr className="text-white">
                                                        <th>Field</th>
                                                        <th>Old Value</th>
                                                        <th>New Value</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        expertAreaData
                                                            .filter(area => area?.temp)
                                                            .map((area, index) => (
                                                                <tr key={index}>
                                                                    <td className="fw-bold">Area</td>
                                                                    <td>{area?.area}</td>
                                                                    <td>{area?.temp}</td>
                                                                </tr>
                                                            ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }


                </div>
            </div >

        </>
    );
};

export default CompareData;
